// Coleção de cosméticos: shinies (equipar/desequipar).
import { api, errorMessage, type Cosmetic } from "../api";
import type { View } from "../router";
import { esc, screen } from "../ui";
import { loadSprites, spriteHtml } from "../sprites";
import { speciesName } from "../data";
import { num, t, type MsgKey } from "../i18n";
import { PDX } from "./market";
import { loadSession } from "../session";

const RARITIES = ["common", "rare", "epic", "legendary"];

export const collectionView: View = (root) => {
  root.innerHTML = screen(t("collection.title"), "/menu", `<div class="bw-textbox">${t("common.loading")}</div>`);
  const body = root.querySelector<HTMLElement>(".screen__body")!;
  let items: Cosmetic[] = [];
  let onlyOwned = false;
  let balance = 0;

  const render = () => {
    const skins = items.filter((c) => c.type === "unit_skin");
    const owned = skins.filter((c) => c.owned).length;
    const list = items.filter((c) => c.type === "unit_skin" && (!onlyOwned || c.owned));
    body.innerHTML = `
      <div class="bw-textbox">${t("collection.text")}</div>
      <div class="bw-row"><button class="bw-btn ${onlyOwned ? "bw-btn--blue" : ""}" data-toggle>${onlyOwned ? t("collection.showingOwned") : t("collection.showOwned")}</button><span class="bw-dim">${t("collection.count", { n: owned, total: skins.length })}</span></div>
      <div data-alert hidden></div>
      <div class="pdx-bar bw-panel"><span class="pdx">${PDX} <b>${num(balance)}</b></span><span class="bw-dim small">${t("pdx.explain")}</span></div>
      <div class="skins">${list.map((c) => `
        <div class="skin-cell"><button class="skin" data-id="${c.id}" data-species="${c.target_species}" ${c.owned ? "" : 'aria-disabled="true" disabled'} ${c.equipped ? 'aria-selected="true"' : ""}>
          ${spriteHtml(c.target_species ?? 1, 80, c.owned)}
          <span>${esc(speciesName(c.target_species ?? 0) ?? c.id)}</span>
          <span class="bw-hint">${c.equipped ? t("shop.equipped") : c.owned ? t("collection.tapToEquip") : RARITIES.includes(c.rarity) ? t(`rarity.${c.rarity}` as MsgKey) : c.rarity}</span>
        </button>${!c.owned && c.price ? `<button class="bw-btn bw-btn--green buy-btn" data-buy-skin="${c.id}">${PDX} ${num(c.price)}</button>` : ""}</div>`).join("")}</div>`;
  };

  body.addEventListener("click", async (e) => {
    const el = e.target as HTMLElement;
    if (el.closest("[data-toggle]")) { onlyOwned = !onlyOwned; render(); return; }
    const buySkin = el.closest<HTMLElement>("[data-buy-skin]");
    if (buySkin) {
      const c = items.find((x) => x.id === buySkin.dataset.buySkin)!;
      const alert = body.querySelector<HTMLElement>("[data-alert]")!;
      if ((c.price ?? 0) > balance) {
        alert.className = "bw-alert bw-alert--error";
        alert.textContent = t("pdx.notEnough");
        alert.hidden = false;
        return;
      }
      if (!buySkin.dataset.confirm) {
        buySkin.dataset.confirm = "1";
        buySkin.textContent = t("pdx.confirm", { price: `${PDX} ${num(c.price ?? 0)}` });
        return;
      }
      try {
        balance = (await api.buyCosmetic(c.id)).pokedollars;
        c.owned = true;
        render();
        void loadSession();
      } catch (err) {
        alert.className = "bw-alert bw-alert--error";
        alert.textContent = errorMessage(err);
        alert.hidden = false;
      }
      return;
    }
    const b = el.closest<HTMLElement>("[data-id]");
    if (!b || b.hasAttribute("disabled")) return;
    const c = items.find((x) => x.id === b.dataset.id)!;
    try {
      await api.equip(`species:${c.target_species}`, c.equipped ? null : c.id);
      c.equipped = !c.equipped;
      render();
    } catch (err) {
      const alert = body.querySelector<HTMLElement>("[data-alert]")!;
      alert.className = "bw-alert bw-alert--error";
      alert.textContent = errorMessage(err);
      alert.hidden = false;
    }
  });

  Promise.all([loadSprites(), api.cosmetics()])
    .then(([, r]) => {
      items = r.cosmetics;
      balance = r.pokedollars;
      render();
    })
    .catch((err) => (body.innerHTML = `<div class="bw-alert bw-alert--error">${esc(errorMessage(err))}</div>`));
};
